import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppDialogContext } from '../../models/app-modal-context';
import { ModalDialogComponent } from '../modal/modal-dialog/modal-dialog.component';
import { FileUploadArea } from '@src/app/core/enums/FileUploadArea';
import { AddAttachmentComponent } from '@src/app/shared/components/add-attachment/add-attachment.component';

@Component({
  selector: 'app-add-image-button',
  templateUrl: './add-image-button.component.html',
  styleUrls: ['./add-image-button.component.css']
})
export class AddImageButtonComponent {
  @Input()
  imageKey: string = '';
  @Input()
  targetImageArea: FileUploadArea = FileUploadArea.General;  
  @Input() lookupKey: string = '';
  @Input() noOfFilesToLimit : number = 1;
  FileUploadArea = FileUploadArea;
  constructor(
    public modalService: BsModalService,
  ){}

  // addNewImage(){
  //   const context: AppDialogContext = AppDialogContext.generate({ 
  //     childComponent: AddAttachmentComponent,
  //     initialState: {
  //       imageKey: this.imageKey,
  //       targetImageArea: this.targetImageArea
  //     }
  //   });
    
  //   const modal = this.modalService.show(ModalDialogComponent, context);
    
  //   if (modal.onHide) {
  //     modal.onHide.subscribe(
  //       result => {
  //         // Handle the result if needed
  //         console.log('Modal closed with result:', result);
  //       },
  //       error => {
  //         console.error(error);
  //       }
  //     );
  //   }
  // }
}
